// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fP","catalogByServiceItem__title":"c-k_fQ"};